var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter-box"},[_c('div',{staticClass:"barContainer"},_vm._l((_vm.max),function(index){return _c('div',{key:index,staticClass:"bar",class:{active: _vm.actual >= (index)}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }